import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Language, Translations } from './types';
import { de } from './de';
import { en } from './en';

const translations: Record<Language, Translations> = { de, en };

interface LanguageState {
  language: Language;
  setLanguage: (lang: Language) => void;
  toggleLanguage: () => void;
}

export const useLanguageStore = create<LanguageState>()(
  persist(
    (set, get) => ({
      language: 'de',
      setLanguage: (language) => set({ language }),
      toggleLanguage: () => set({ language: get().language === 'de' ? 'en' : 'de' }),
    }),
    {
      name: 'ukonnx-language',
    }
  )
);

export function useTranslation() {
  const { language, setLanguage, toggleLanguage } = useLanguageStore();
  const t = translations[language];
  
  return {
    t,
    language,
    setLanguage,
    toggleLanguage,
  };
}

export type { Language, Translations };
